// Import des fonctions Firebase nécessaires
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Configuration Firebase
// Vous devrez remplacer ces valeurs par celles de votre projet Firebase
const firebaseConfig = {
  apiKey: "AIzaSyDej5YKY4jMWuzH3BpJq16AiZ6V2zjjWwA",
  authDomain: "myfirstgame-820b8.firebaseapp.com",
  projectId: "myfirstgame-820b8",
  storageBucket: "myfirstgame-820b8.appspot.com",
  messagingSenderId: "201218659144",
  appId: "1:201218659144:web:48b28de800a403e5e4597d",
  measurementId: "G-KP34GEBZBP"
};

// Initialisation de Firebase
const app = initializeApp(firebaseConfig);

// Export des services Firebase
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app; 